import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=22932c12&"
import script from "./MainContent.vue?vue&type=script&lang=js&"
export * from "./MainContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports